import { render } from "./StepButtonsComponent.vue?vue&type=template&id=08fc505e"
import script from "./StepButtonsComponent.vue?vue&type=script&lang=js"
export * from "./StepButtonsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__